<template>
  <div class="customer-report-container">
    <header class="report-header">
      <img src="./img.png" alt="Ingersoll Rand Logo" ref="logo" class="logo">
      <div class="report-title">
        <h1>Ingersoll Rand Year 2025 PC Report</h1>
      </div>
    </header>
    <img src="./img3.png" ref="coverImage" class="cover-image">
    <div class="report-title">
      <h1>智慧工业, 精准赋能</h1>
      <p>通过精准而全面的数据采集、萃取和提炼，洞察机组过去，现在和未来的运行指数，实现不同业务端口多样需求的理想解决方案</p>
    </div>
    <div class="report-content" :class="{fontinfo:isExport}">

        <h2>客户维度数据:</h2>

      <table class="info-table">
        <tbody>
        <tr>
          <td class="info-item" style="width: 30%;">
            <span>客户名称</span>
            <p>{{ customerName || 'N/A' }}</p>
          </td>
          <td class="info-item"  style="width: 30%;">
            <span>客户资产数量</span>
            <p>{{ customerAssetsCount || 'N/A' }}</p>
          </td>
          <td class="info-item">
            <span>报告时间</span>
            <p>{{ reportTime || "N/A" }}</p>
          </td>
        </tr>
        <tr>

          <td class="info-item" v-bind:style="{ padding: '10px', borderRadius: '4px' }">
            <span>健康状态:</span>
        
              <p v-bind:style="{ color: 'green' || '#f5f5f5' }">{{ healthStatus.status || 'N/A' }}</p>
              

          </td>
          <td class="info-item" v-bind:style="{ padding: '10px', borderRadius: '4px' }">
            <span>利用率状态:</span>
            <p v-bind:style="{ color: 'green' || '#f5f5f5' }">{{ rateStatus.status || 'N/A' }}</p>
          </td>
          <td class="info-item">
            <span>Trip数:</span>
            <p>{{ tripInfoCount }}</p>
          </td>
        </tr>
        <tr v-if="localReportConfig.alertInfoEnabled === 'true'">

          <td class="info-item">
            <span>Warning数:</span>
            <p>{{ warningInfoCount }}</p>
          </td>
        </tr>
      </tbody>
      </table>

      <table class="chart-table">
        <thead>
        <tr>
          <td :rowspan="contractList.length + 1">合同信息</td>
          <td>合同编号</td>
          <td>设备编号</td>
          <td>合同状态</td>
          <td>开始日期</td>
          <td>结束日期</td>
          <td>合同类型</td>
        </tr>
        <tr v-for="(item, index) in contractList" :key="item.id">
          <td>{{ item.serviceContractName}}</td>
          <td>{{ item.assetSerialNumber}}</td>
          <td>{{ item.status}}</td>
          <td>{{ item.startDate}}</td>
          <td>{{ item.endDate}}</td>
          <td>{{ item.serviceContractType}}</td>
        </tr>
        </thead>
      </table>

      <br/>

      <table class="chart-table">
        <thead>
        <tr>
          <td :rowspan="deviceInfoList.length + 1">设备信息</td>
          <td>设备型号</td>
          <td>序列号</td>
          <td>当前运行小时数</td>
          <td>开机日期</td>
          <td>发运日期</td>
          <td>服务工程师</td>
        </tr>
        <tr v-for="(item, index) in deviceInfoList" :key="item.id">
          <td>{{ item.modelDesc}}</td>
          <td>{{ item.dsn }}</td>
          <td>{{ item.calcRunningTime }}</td>
          <td>{{ item.installDate }}</td>
          <td>{{ item.deliveryDate }}</td>
          <td>{{ item.responsibleEngineerName }}</td>
        </tr>
        </thead>
      </table>
    
      
      <div v-if="tripInfo != null && localReportConfig.alertInfoEnabled === 'true'" style="width:100%">
        <span>Top 3 Trip:</span>
        <table class="top-3-trip">
          <thead>
          <tr>
            <th>设备号</th>
            <th>网关号</th>
            <th>报警类型</th>
            <th>报警码</th>
            <th>报警内容</th>
            <th>报警数</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in tripInfo.slice(0, 3)">
            <td>{{ item.Dsn }}</td>
            <td>{{ item.Gsn }}</td>
            <td>{{ item.AlarmType }}</td>
            <td>{{ item.AlarmCode }}</td>
            <td>{{ item.AlarmContent }}</td>
            <td>{{ item.AlarmCount }}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <div v-if="localReportConfig.serviceInfoEnabled === 'true'">
        <h2>工单记录</h2>
        <table class="sfa-table" >
          <thead>
          <tr>
            <th>工单编号</th>
            <th>设备型号</th>
            <th>序列号</th>
            <th>客户申诉</th>
            <th>服务时间</th>
            <th>服务内容1</th>
            <th>服务内容2</th>
            <th>核定工时</th>
            <th>工时耗费</th>
            <th>合同控制号</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in sfaList" :key="item.SFID">
            <td>{{ item.name }}</td>
            <td>{{ item.modelDesc }}</td>
            <td>{{ item.dsn }}</td>
            <td>{{ item.complainType }}</td>
            <td>{{ item.faultDate }}</td>
            <td>
              {{ item.faultName01 || '' }}
            </td>
            <td>
              {{ item.faultName02 || '' }}
            </td>
            <td>
              {{ item.approvalLaborHour01 || '' }}
            </td>
            <td>
              {{ item.approvalLaborHour01 ? item.approvalLaborHour01 * 540 : '' }}
            </td>
            <td>
              {{ item.serviceContractControlNumber || '' }}
            </td>
          </tr>
          <tr v-if="sfaList.length > 0" style="background-color: #e6f7ff;">
            <td colspan="7"><strong>总计</strong></td>
            <td><strong>{{ sfaSummary.totalLaborHours }}</strong></td>
            <td><strong>{{ sfaSummary.totalApprovedLaborHours }}</strong></td>
            <td></td>
          </tr>
          </tbody>
        </table>
      </div>

      <div v-if="localReportConfig.sparePartInfoEnabled === 'true'">
        <h2>备件更换记录</h2>
        <table class="sfa-table" >
          <thead>
          <tr>
            <th>产品编号</th>
            <th>型号</th>
            <th>服务时间</th>
            <th>主类</th>
            <th>数量</th>
            <th>总金额(未税)</th>
            <th>合同控制号</th>

          </tr>
          </thead>
          <tbody>
          <tr v-for="product in sfaProducts">
            <td>{{ product.product?.productCode }}</td>
            <td>{{ product.product?.modelCode }}</td>
            <td>{{ product.serviceDate }}</td>
            <td>{{ product.product?.serviceProductPrimaryCategory }}</td>
            <td>{{ product.quantity }}</td>
            <td>{{ product.listPrice }}</td>
            <td>
              {{ product.serviceContractControlNumber || '' }}
            </td>
          </tr>
          <tr v-if="sfaProducts.length > 0" style="background-color: #e6f7ff;">
            <td colspan="4"><strong>总计</strong></td>
            <td><strong>{{ sparePartSummary.totalQuantity }}</strong></td>
            <td><strong>{{ sparePartSummary.totalCost.toFixed(2) }}</strong></td>
            <td></td>
          </tr>

          </tbody>
        </table>
      </div>

    </div>

    <h2>设备维度数据:</h2>
    <div ref="deviceHealthReport">
    <div v-for="config in this.deviceConfigs" >
      <device-health-report :report-config="config" :ref="config.healthReportId"/>
    </div>
  </div>

    <div class="editor-section">
      <h2>综合建议</h2>
      
      <textarea ref="inputnotes" v-model="notes" placeholder="在此输入综合建议..." rows="5"></textarea>
    </div>

    <div class="footer">
      <p > <h3 style="text-align:left">状态定义:</h3></p>

    <div class="health-definition footer">
      <p > <h3 style="text-align:left">1. 健康状态定义:</h3></p>
      <div style="display: flex;text-align:left;">
      
      <p style=" margin-right: 20px;"><span style="font-weight: bold;">健康：</span><span>绿色, 一个月Trip小于2 Warning小于4</span></p>

      <p style=" margin-right: 20px;"><span style="font-weight: bold;">亚健康：</span><span>黄色, 一个月Trip大于等于2小于4 Warning小于8</span></p>

      <p style=" margin-right: 20px;"><span style="font-weight: bold;">非健康：</span><span>红色, 一个月Trip大于等于4 Warning大于等于8</span></p>

      </div>
      <div style="display: flex;text-align:left;">
        <p style=" margin-right: 20px;"><span style="font-weight: bold;">Notes: </span><span>trip的优先级高于Warning, 如果Trip达到数量直接报告健康状态，如果Trip没有达标则看warning</span></p>
      </div>
      
  </div>

    <div class="load-rate-definition footer">
      <p > <h3 style="text-align:left">2. 利用率状态定义:</h3></p>
      <div style="display: flex; text-align:left;">
        <p style=" margin-right: 20px;"><span style="font-weight: bold;">高利用率：</span><span>75%以上</span></p>

      <p style=" margin-right: 20px;"><span style="font-weight: bold;">中度利用率：</span><span>35%-75%</span></p>

      <p style=" margin-right: 20px;"><span style="font-weight: bold;">低利用率：</span><span>35%以下</span></p>
      </div>
    </div>
  </div>

    <div class="export-button">
      <el-button type="primary" ref="exportButton" @click="exportToWord">报告导出</el-button>
    </div>

  </div>
</template>

<script>
import {
  GetCustomerHealthReport,
  GetDeviceBasicInfo,
  GetHealthReport,
  SaveCustomerNotes,
  GetLifecycleCoreData,
  GetContractList, GetSfaInfoList
} from "@/api/api";
import DeviceHealthReport from "../../components/report/DeviceHealthReport.vue";

import axios from '../../../utils/http';

export default {
  components: {
    "device-health-report": DeviceHealthReport
  },
  data() {
    return {
      isExport: false,
      customerName: "",
      customerAssetsCount: 0,
      engineerName: "",
      contractType: "",
      reportTime: {},
      healthStatus: {},
      rateStatus: {},
      notes: "",
      calcRunningHour: "",
      calcLoadedHour: "",
      loadRate: "",
      rate: "",
      tripInfo: [],
      warningInfo: [],
      tripInfoCount: 0,
      warningInfoCount: 0,
      tripInfoTop3: [],
      deviceConfigs: [],
      dsns: [],
      gsns: [],
      localReportConfig: {},
      deviceInfoList: [],
      contractList: [],
      sfaList: [],
      sfaProducts: [],
      sfaSummary: {
          totalLaborHours: 0,
          totalApprovedLaborHours: 0,
          totalServiceCount: 0
      },
      sparePartSummary: {
        totalQuantity: 0,
        totalCost: 0
      }
    };
  },
  props: {},
  created() {
    this.localReportConfig = {...this.$route.query};
    this.cycleDate = this.getLastDayOfMonth(this.localReportConfig.cycle);
    GetCustomerHealthReport(this.localReportConfig.healthReportId).then((res) => {
      if (res && res.result) {
        this.notes = res.result.notes;
      }
    });
  },
  mounted: function () {
    let dsn = this.localReportConfig.dsn;
    let gsn = this.localReportConfig.gsn;
    let healthReportId = this.localReportConfig.healthReportId;
    if (dsn) {
      this.dsns = dsn.split(",");
    }
    if (gsn) {
      this.gsns = gsn.split(",");
    }

    this.customerAssetsCount = this.dsns.length;
    this.getCustomerHealthReport(healthReportId);
  },
  watch: {
    notes: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.saveNotes();
        }
      },
      immediate: false,
      deep: true
    }
  },
  methods: {
    async saveNotes() {
      if (!this.notes) {
        console.log('No notes to save');
        return;
      }
      try {
        const response = await SaveCustomerNotes(
          this.localReportConfig.healthReportId,
          this.notes);
        console.log('Notes saved successfully:', response);
      } catch (error) {
        console.error('Error saving notes:', error);
      }
    },
    getCustomerHealthReport: async function (healthReportId) {
      let res = await GetCustomerHealthReport(healthReportId);
      let result = res.result;
      let deviceReportIds = result.deviceReportIds;
      let split = [];
      if (deviceReportIds) {
        split = deviceReportIds.split(",");
      }
      if (!(this.dsns.length > 0 && (this.dsns.length == this.gsns.length && this.dsns.length == split.length))) {
        return;
      }

      this.customerName = result.customerName;
      this.reportTime = result.cycle;
      this.calcRunningHour = result.calcRunningHour;
      this.calcLoadedHour = result.calcLoadedHour;
      this.loadRate = result.loadRate;
      this.rate = result.rate;

      for (let i = 0; i < split.length; i++) {
        let id = split[i];
        let res = await this.getHealthReport(id);
        if (res) {
          let result = res;
          this.tripInfo = [...this.tripInfo, ...JSON.parse(result.tripInfo || '[]')];
          this.warningInfo = [...this.warningInfo, ...JSON.parse(result.warningInfo || '[]')];
        }
      }

      this.tripInfo.forEach(t => this.tripInfoCount += t.AlarmCount);
      this.warningInfo.forEach(w => this.warningInfoCount += w.AlarmCount);
      let sort = this.tripInfo.sort((a, b) => {
        return b.AlarmCount - a.AlarmCount;
      });
      let slice = sort.slice(0, 3);
      this.tripInfoTop3 = slice;

      this.healthStatusCalc();
      this.rateStatusCalc();

      let dsns = [];
      for (let i = 0; i < split.length; i++) {
        let deviceReportId = split[i];
        let dsn1 = this.dsns[i];
        let gsn1 = this.gsns[i];
        let config = {
          ...this.localReportConfig
        };
        config.dsn = dsn1;
        config.gsn = gsn1;
        dsns.push(dsn1);
        config.healthReportId = deviceReportId;
        config.cycleType = "month";
        this.deviceConfigs.push(config);
        let deviceBasicInfo = await this.deviceBasicInfo(dsn1, gsn1, this.cycleDate);
        let lifecycleCoreData = await this.lifecycleCoreData(dsn1, gsn1);
        deviceBasicInfo.dsn = dsn1;
        deviceBasicInfo.gsn = gsn1;
        deviceBasicInfo.calcRunningTime = lifecycleCoreData.calcRunningHour;
        this.deviceInfoList.push(deviceBasicInfo);
      }
      let contractList = await this.getContractList(dsns);
      if (this.localReportConfig.serviceInfoEnabled) {
        for(let i = 0; i < dsns.length; i++) {
          let res = await GetSfaInfoList(dsns[i]);
          if (res && res.result) {
            res.result.forEach((item) => {item.dsn = dsns[i];item.modelDesc = this.deviceInfoList[i].modelDesc;})
            this.sfaList = [...this.sfaList, ...res.result];
          }
        }
        if (this.sfaList.length > 0) {
          this.sfaProducts = this.sfaList.flatMap((item) => {
            return item.sfaProducts;
          });
        }
        this.sfaSummary.totalServiceCount = this.sfaList.length;

        this.sfaSummary.totalApprovedLaborHours = this.sfaList.reduce((total, item) => {
          const hours = parseFloat(item.approvalLaborHour01) || 0;
          return total + hours * 540; // 计算核定工时耗费
        }, 0);

        this.sfaSummary.totalLaborHours = this.sfaList.reduce((total, item) => {
          const hours = parseFloat(item.approvalLaborHour01) || 0;
          return total + hours;
        }, 0);

        this.sparePartSummary.totalQuantity = this.sfaProducts.reduce((total, product) => {
          const quantity = parseInt(product.quantity) || 0;
          return total + quantity;
        }, 0);

        this.sparePartSummary.totalCost = this.sfaProducts.reduce((total, product) => {
          const price = parseFloat(product.listPrice) || 0;
          const quantity = parseInt(product.quantity) || 0;
          return total + price * quantity;
        }, 0);
      }
      this.contractList = contractList;
    },
    async deviceBasicInfo(dsn, gsn, cycle) {
      let res = await GetDeviceBasicInfo(dsn, gsn, 'month', cycle);
      if (!res || !res.result) {
        return {};
      }
      return res.result;
    },
    async lifecycleCoreData(dsn, gsn) {
      let res = await GetLifecycleCoreData(dsn, gsn, 'month', this.localReportConfig.cycle);
      if (!res || !res.result) {
        return {};
      }
      return res.result;
    },
    async getContractList(dsns) {
      let res = await GetContractList(dsns);
      if (!res || !res.result) {
        return {};
      }
      return res.result;
    },
    async getHealthReport(healthReportId) {
      let res = await GetHealthReport(healthReportId);
      let result = res.result;
      return result;
    },
    healthStatusCalc() {
      if (this.warningInfoCount < 4 && this.tripInfoCount < 2) {
        this.healthStatus = {
          status: '健康',
          color: '#67C23A'
        }
      } else if (this.warningInfoCount < 8 && this.tripInfoCount < 4) {
        this.healthStatus = {
          status: '亚健康',
          color: '#E6A23C'
        }
      } else if (this.warningInfoCount >= 8 && this.tripInfoCount >= 4) {
        this.healthStatus = {
          status: '不健康',
          color: '#F56C6C'
        }
      } else {
        this.healthStatus = {
          status: '未知',
          color: '#f5f5f5'
        }
      }
    },
    rateStatusCalc() {
      if (this.loadRate >= 0.75) {
        this.rateStatus = {
          status: '高利用率',
          color: '#67C23A'
        }
      } else if (this.loadRate >= 0.35) {
        this.rateStatus = {
          status: '中度利用率',
          color: '#E6A23C'
        }
      } else {
        this.rateStatus = {
          status: '低利用率',
          color: '#F56C6C'
        }
      }
    },
    img2Base64(imgElement) {
      return new Promise((resolve, reject) => {
        // 创建一个新的 Image 对象
        const img = new Image();
        img.crossOrigin = 'Anonymous'; // 如果需要跨域图片，设置跨域属性
        img.src = imgElement.src;
        // 等待图片加载完成
        img.onload = function () {
          // 创建一个 canvas 元素
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          // 设置 canvas 的宽高与图片一致
          canvas.width = img.width;
          canvas.height = img.height;

          // 将图片绘制到 canvas 上
          ctx.drawImage(img, 0, 0);

          // 将 canvas 转换为 Base64 图片
          const base64 = canvas.toDataURL('image/png'); // 可以指定格式，如 'image/jpeg'

          console.log(base64); // 输出 Base64 编码的图片
          resolve(base64);
        }
        img.onerror = function () {
          reject();
        };
      });
    },
    getLastDayOfMonth(dateStr) {
      const [year, month] = dateStr.split('-').map(Number);
      const lastDate = new Date(year, month, 0); // 关键：设置为下个月的第0天
      const pad = (num) => String(num).padStart(2, '0');
      return `${year}-${pad(month)}-${pad(lastDate.getDate())}`;
    },
    async exportToWord() {
      // 确保图表已经渲染
      await this.$nextTick();
      const logo = this.$refs.logo;
      const coverImage = this.$refs.coverImage;
      const logoBase64 = await this.img2Base64(logo);
      const coverImageBase64 = await this.img2Base64(coverImage);
      const inputnotes = this.$refs.inputnotes;

      const newLogo = document.createElement('img');
      newLogo.src = logoBase64;
      newLogo.width = logo.width;
      newLogo.height = logo.height;

      const newCoverImage = document.createElement('img');
      newCoverImage.src = coverImageBase64;
      newCoverImage.width = '100%';
      newCoverImage.height = 'auto';

      logo.parentNode.replaceChild(newLogo, logo);
      coverImage.parentNode.replaceChild(newCoverImage, coverImage);

      // 移除导出按钮
      const exportButton = this.$refs.exportButton.$el;
      if (exportButton) {
        exportButton.remove();
      }

      const notes = document.createElement('p');
      notes.innerHTML = this.notes;

      inputnotes.parentNode.replaceChild(notes, inputnotes);
      this.isExport = true;
      await this.$nextTick();

      const deviceHealthReportDiv = this.$refs.deviceHealthReport;
      //const div = document.createElement('div');

      // 获取样式
      const collectAllStyles = () => {
        const styleSheets = Array.from(document.styleSheets);
        const styles = [];

        styleSheets.forEach(sheet => {
          try {
            Array.from(sheet.cssRules).forEach(rule => {
              styles.push(rule.cssText);
            });
          } catch (e) {
            // 跨域样式表忽略
          }
        });

        return styles.join('\n');
      };
      const allStyles = collectAllStyles();

      const listeners = [];
      for (let index = 0; index < this.deviceConfigs.length; index++) {
        const config = this.deviceConfigs[index];
        let content = await this.$refs[config.healthReportId][0].exportToWord();
        listeners.push(content[2]);
      }
      //deviceHealthReportDiv.parentNode.replaceChild(div, deviceHealthReportDiv);

      const reportContent = document.querySelector('.customer-report-container').innerHTML;

      console.info(reportContent);

      // 将报告内容转换为 Word 文档
      console.info("reportContent");
      console.log(reportContent)

      let html = `
                  <!DOCTYPE html>
                  <html>
                  <head>
                   <meta charset="utf-8"/>
                  <style>
                  ${allStyles}
                  </style>
                  </head>
                  <body>
                  ${reportContent}
                  </body>
                  </html>
                `;
      console.info(html);

      this.downloadFile(`/api/upload/htmltoword`, html);

      //恢复页面
      listeners.forEach(a => a());
      newLogo.parentNode.replaceChild(logo, newLogo);
      newCoverImage.parentNode.replaceChild(coverImage, newCoverImage);
      //div.parentNode.replaceChild(deviceHealthReportDiv, div);
      notes.parentNode.replaceChild(inputnotes, notes);

      // 重新添加导出按钮
      if (exportButton) {
        document.querySelector('.export-button').appendChild(exportButton);
      }
      this.isExport = false;

    },
    downloadFile(fileUrl, html) {
      axios.post(fileUrl, {html: html}, {responseType: 'blob'})
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "health_report.docx");
            document.body.appendChild(link);
            link.click();
          })
          .catch(error => {
            console.error(error);
          });
    }
  }
}
</script>

<style scoped>
/* styles.css */
.customer-report-container {
  font-family: Arial, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.report-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.logo {
  width: 200px;
  background-color: white; /* 设置 logo 背景为白色 */
}

.report-title {
  text-align: center;
}

.report-title h1 {
  margin: 0;
}

.report-title p {
  margin: 0;
  color: #666;
}

.info-section {
  margin-top: 50px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

.info-section2 {
  margin-top: 50px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

.info-item {
  background: #f5f5f5;
  padding: 10px;
  border-radius: 4px;

}
.fontinfo {
  font-size: 14px;
}
.info-item span {
  font-weight: bold;
}

.chart-section {
  margin-top: 20px;
}

.chart-table {
  border: 1px solid #000; /* 添加边框 */
  margin-top: 20px;
  margin: 20px 0 40px 0;
  background-color: #f5f5f5; /* 设置背景色为灰色 */
  width: 100%; /* 确保表格宽度与其他内容对齐 */
  border-collapse: collapse; /* 合并边框 */
  font-size: 13px;
}

.chart-table th,
.chart-table td {
  border: 1px solid #000; /* 添加边框 */
  padding: 8px;
  text-align: left;
  font-size: 13px;
}

.chart-table thead tr:first-child th,
.chart-table thead tr:nth-child(2) th {
  border: none; /* 隐藏特定单元格的边框 */
}

.chart-graph {
  position: relative;
  width: 100%; /* 确保图表宽度与其他内容对齐 */
  margin-top: 20px;
  padding-top: 20px;
}

#chart {
  width: 100%;
  height: 300px;
}

div.info-section p {
  color: red;
}

div.info-section2 p {
  color: red;
}

.export-button {
  margin-top: 100px;
  text-align: center;
}

.top-3-trip {
  border: 1px solid #000; /* 添加边框 */
  margin-top: 20px;
  background-color: #f5f5f5; /* 设置背景色为灰色 */
  width: 100%; /* 确保表格宽度与其他内容对齐 */
  border-collapse: collapse; /* 合并边框 */
}

.top-3-trip th,
.top-3-trip td {
  border: 1px solid #000; /* 添加边框 */
  padding: 8px;
  text-align: left;
  vertical-align: middle; /* 垂直居中对齐 */
  font-size: 13px;
}

.report-title {
  text-align: left;
  padding-left: 20px;
  border-left: 5px solid #ff4500; /* 橙色边框 */
}

.report-title h1 {
  margin: 0;
  color: #333;
  font-size: 24px;
}

.report-title p {
  margin: 0;
  color: #666;
  font-size: 16px;
}

.cover-image {
  width: 100%;
  margin-bottom: 20px;
}

.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.header {
  background-color: #FF3399;
  color: white;
  text-align: center;
}

.health-definition {
  margin-top: 20px;
}

.health-definition h3 {
  margin: 10px 0;
}

.health-definition p {
  margin: 5px 0;
}

.notes {
  margin-top: 20px;
  font-style: italic;
}

.header-load-rate {
  background-color: #990033;
  color: white;
  text-align: center;
}

.load-rate-definition {
  margin-top: 20px;
}

.load-rate-definition p {
  margin: 5px 0;
}

.editor-section {
  margin-top: 40px;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
}

.editor-section h2 {
  margin-bottom: 10px;
}

.editor-section textarea {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical; /* 允许垂直调整大小 */
}

.footer {
  margin-top: 50px;
  font-size: 12px; /* 小字体 */
  color: #666; /* 灰色字体 */
  text-align: center;
 text-align:left;
}

.health-definition.footer {
  margin-top: 10px;
  font-size: 12px; /* 小字体 */
  color: #666; /* 灰色字体 */
  text-align: center;
}

.load-rate-definition.footer {
  margin-top: 10px;
  font-size: 12px; /* 小字体 */
  color: #666; /* 灰色字体 */
  text-align: center; /* 居中对齐 */
}

.load-rate-definition.footer h3 {
  margin: 10px 0;
}

.load-rate-definition.footer p {
  margin: 5px 0;
}

.info-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 20px; /* 保持原有间隙 */
  margin: 20px 0 40px 0;
  color: red;
}

.info-table td.info-item {
  background: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
  width: calc(100% / 3 - 13px); /* 保持三列等宽 */
  vertical-align: top;
  margin-bottom: 30px;
}

.info-table span {
  font-weight: bold;
  display: block;
  margin-bottom: 5px;
}

.info-table p {
  margin: 0;
  color: #666;
}

.info-section, .info-section2 {
  width: 100%;
  border-collapse: separate;
  border-spacing: 20px;
  margin: 20px 0;
}

.info-section td, .info-section2 td {
  background: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
  vertical-align: top;
}

.info-section span, .info-section2 span {
  font-weight: bold;
  display: block;
  margin-bottom: 5px;
}

.info-section p, .info-section2 p {
  margin: 0;
  color: #666;
}

/* 针对列数不同的表格 */
.info-section { /* 默认3列 */
  table-layout: fixed;
}
.info-section tr td {
  width: calc(100% / 3);
}

.info-section2 { /* 4列 */
  table-layout: fixed;
}
.info-section2 tr td {
  width: 25%;
}

/* 确保与 chart-table 样式一致 */
.sfa-table {
  border: 1px solid #000;
  margin-top: 20px;
  background-color: #f5f5f5;
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.sfa-table th,
.sfa-table td {
  border: 1px solid #000;
  padding: 8px;
  text-align: left;
  font-size: 13px;
}

.styled-link {
            color: #007BFF; /* 蓝色文字 */
            text-decoration: none; /* 去掉下划线 */
            font-weight: bold; /* 粗体 */
            transition: color 0.3s ease; /* 平滑过渡效果 */
        }

        .styled-link:hover {
            color: #0056b3; /* 鼠标悬停时变为更深的蓝色 */
            text-decoration: underline; /* 悬停时显示下划线 */
        }
</style>
